import React from "react";

class NumberDisplay extends React.Component {
  constructor(props) {
    super(props);
    this.state = { isEditing: false };
  }

  toCurrency(number) {
    try {
      const formatter = new Intl.NumberFormat(navigator.language, {
        style: "currency",
        currency: this.props.currency,
        maximumFractionDigits: this.props?.decimalPlaces || 2,
      });
      return formatter.format(number);
    } catch (error) {
      console.log(error);
      return number;
    }
  }

  render() {
    return (
      <div className={this.props.className}>
        {this.toCurrency(this.props.value)}
      </div>
    );
  }
}

export default NumberDisplay;
